import { render } from "./BaseKLogo.vue?vue&type=template&id=5428fbea"
import script from "./BaseKLogo.vue?vue&type=script&lang=js"
export * from "./BaseKLogo.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__